import script from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=7cb3bc13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb3bc13"]])

export default __exports__